import { useRef } from 'react';

/**
 * Hook per gestire l'inizializzazione del material cascade
 * Usa un flag per inizializzare solo una volta quando il formik è disponibile
 */
export const useMaterialCascadeInit = () => {
    const isInitialized = useRef(false);

    const initializeOnce = (materialCascade: any) => {
        if (!isInitialized.current && materialCascade && materialCascade.initializeFormMaterials) {
            try {
                materialCascade.initializeFormMaterials();
                isInitialized.current = true;
            } catch (error) {
                // Don't set initialized flag if there was an error
            }
        } else if (!isInitialized.current) {
        }
    };

    const resetInitialization = () => {
        isInitialized.current = false;
    };

    return { initializeOnce, resetInitialization };
};
